import { createContext } from "react";

const AppContext = createContext({
    accessToken: '',
    setAccessToken: (newValue) => {},
    pagePaths: [],
    setPagePaths: (newValue) => {},
    rawPageCarCode: '',
    setRawPageCarCode: (newValue) => {},
});

export default AppContext;